import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

const state = {
  promiseBtn: ["video", "add"],
  isdark: true,
  isFullScreen: false,
  carMsg: {
    carNo: "",
    play: 1,
  },
  personMsg: {},
  control: false,
  menu: {
    //菜单状态
    status: false, //false--展开 true--缩进
  },
  topMenuList: [{ name: "首页大屏", link: "/control", now: 0, id: 0 }],
  nowActiveTitle: "",
  csr: {},
  dots: {},
  bendi2: {
    name: "鑫梓润数智城市管理云平台",
    extend: "2222222",
    mainLogoPic: "static/logo/ly2.png",
    linkLogoPic: "",
    loginBgPic: "static/login/ly.jpg",
    footerEnabled: false,
    footerLink: "http://beian.miit.gov.cn",
    footerTitle: "",
    linkTitle: "555555",
    mainTitle: "",
    remark: "7777777",
    bgColor: "#f5f5f5",
    themeName: "black",
    fontColor: "#fff",
    themeColor: "#333",
    aidColor: "#0bbf11",
    adornColor: "#0d98d6",
    otherColor: "#e9f1f7",
    company: "",
  },
  bendi: {
    name: "深圳来源电子数智城市管理云平台",
    extend: "2222222",
    mainLogoPic: "static/logo/ly1.png",
    linkLogoPic: "static/logo/ly.png",
    loginBgPic: "static/login/ly.jpg",
    footerEnabled: true,
    footerLink: "http://beian.miit.gov.cn",
    footerTitle: "备案号 | 粤ICP备16117222号",
    linkTitle: "555555",
    mainTitle: "来源智慧环卫",
    remark: "7777777",
    bgColor: "#f5f5f5",
    themeName: "black",
    fontColor: "#fff",
    themeColor: "#333",
    aidColor: "#0bbf11",
    adornColor: "#0d98d6",
    otherColor: "#e9f1f7",
    company: "深圳来源电子有限公司",
  },
  inCss(data) {
    /* var rootcss = document.getElementById("rootcss");
    rootcss.innerHTML =
      ":root {--loginColor:" +
      data.adornColor +
      ";}" */
  },
};
var tmplId = getUrlKey("t");
if (tmplId == null) {
  state.csr = state.bendi;
  state.inCss(state.csr);
  document.getElementById("webTitle").innerHTML = state.csr.name;
  document.getElementById("webPhoto").href = "static/logo/ly1.png";
} else {
  setTimeout(() => {
    gettmpl();
  }, 200);
}

function gettmpl() {
  let params = {
    id: tmplId,
  };
  axios({
    method: "post",
    url: "/tmpl/item",
    data: params,
  }).then((res) => {
    console.log(res);
    state.csr = res.data.data;
    state.inCss(res.data.data);
    document.getElementById("webTitle").innerHTML = state.csr.name;
    document.getElementById("webPhoto").href = state.csr.smallLogo
      ? state.csr.smallLogo
      : "static/logo/defaul.png";
  });
}
function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}
export default new Vuex.Store({
  state,
});



// WEBPACK FOOTER //
// ./src/vuex/store.js